'use es6';

import get from 'transmute/get';
import { Map as ImmutableMap } from 'immutable';
import { formatToReferencesList } from 'reference-resolvers/lib/formatReferences';
export const formatWorkflowFolders = formatToReferencesList({
  getId: get('id'),
  getLabel: get('name')
});
export const formatWorkflowFoldersResponse = ({
  hasMore,
  offset = 0,
  results = []
}) => ImmutableMap({
  hasMore,
  offset,
  count: results.length,
  results: formatWorkflowFolders(results)
});